module.exports = __webpack_public_path__ + "static/steel-erecting-and-cladding-5-a9c215bfe2f4f076580a09359530b4e3.jpg";